export const navbarObj = {
  gencatIcon: require('../../images/gencatLogo.png'),
  accesibilityIcon: require('../../images/accesibility.png'),
  commentIcon: require('../../images/comment.png'),
  questionIcon: require('../../images/icon-guia-tutorial.png'),
  shareIcon: require('../../images/share.png'),
  fontSizeIcon: require('../../images/text-formatting.png'),
  contrastIcon: require('../../images/contrast.png'),
  moreIcon: require('../../images/more.png'),
  deleteIcon: require('../../images/delete.png')
};
